import { Menu, X } from "lucide-react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const BottomMenu = ({ showMenu, setShowMenu, onCancel, onQuit }) => {
    const userDetailsAll = JSON.parse(localStorage.getItem("userDetailsAll")) || {};
    let roleName = userDetailsAll?.session_info?.role_name || null
    const navigate = useNavigate()

    const handleFinishCleaning = () => {
        setShowMenu(false);
        if (typeof onQuit === 'function') {
            onQuit();
        } else {
            navigate('/dashboard')
        }
    };

    return (
        <div className="container-fluid text-center">
            {/* Toggle Button */}
            <button className="toggle-btn" onClick={() => setShowMenu(!showMenu)}>
                {showMenu ? <X /> : <Menu />}
            </button>

            {/* Persistent Bottom Menu */}
            <div className={`bottom-menu ${showMenu ? "show" : ""}`}>
                <div className="menu-content">
                    {/* <button className="btn btn-success mx-2">Task List</button> */}
                    <button className="btn btn-info mx-2" onClick={() => { setShowMenu(false); if (typeof onCancel === 'function') { onCancel(); } }}>Cancel</button>
                    <button className="btn btn-danger mx-2" onClick={handleFinishCleaning}>
                        {roleName === 'room attendant' ? 'Stop Cleaning' : 'Quit Inspection'}
                    </button>
                </div>
            </div>

            {/* Background Overlay when menu is open */}
            {showMenu && <div className="overlay" onClick={() => setShowMenu(false)}></div>}
        </div>
    );
};

export default BottomMenu;
